module.exports = __webpack_public_path__ + "static/Flavor_18AMT90221-62701647b78eb7c3d1b80b9bf6472aff.pdf";